import * as actionTypes from '../constants/actionTypes';
export function showGrid() {
    return {
        type: actionTypes.SHOW_GRID,
    };
}
export function hideGrid() {
    return {
        type: actionTypes.HIDE_GRID,
    };
}
export function imageThumbLoaded(id) {
    return {
        type: actionTypes.IMAGE_THUMB_LOADED,
        id: id,
    };
}
export function imageThumbFailed(id) {
    return {
        type: actionTypes.IMAGE_THUMB_FAILED,
        id: id,
    };
}
